import { useState, useEffect } from 'react';
import { Button, Grid, TextField, Typography } from '@mui/material';
import NavigationDrawer from '../../../../components/navigationDrawer';
import restaurantStyle from './style';
import DynamicTable from '../../../../components/dynamicTable';
import moment from 'moment';
import ComplaintsDialog from './complaintsDialog';
import { useNavigate } from 'react-router-dom';
import {
  getAllComplaints,
  updateRestStatus,
} from './../../../../services/complaints/index';
import Loader from '../../../../components/loader';
import SnackbarAlert from './../../../../components/snackbar/SnackbarAlert';
import {
  updateCategoryStatus,
  updateCategoryStatusRejected,
} from '../../../../services/categories';
import { DateRangePicker } from 'react-dates';

const headerData = [
  {
    id: 'name',
    numeric: false,
    disablePadding: true,
    label: 'User Name',
  },
  {
    id: 'email',
    numeric: false,
    disablePadding: true,
    label: 'Email',
  },
  {
    id: 'message',
    numeric: true,
    disablePadding: false,
    label: 'Complain Message',
  },
  {
    id: 'datetime',
    numeric: true,
    disablePadding: false,
    label: 'Date & Time',
  },
  {
    id: 'isApproved',
    numeric: true,
    disablePadding: false,
    label: 'UnAnswered/Answered',
  },
];

const displayRows = [
  'userName',
  'email',
  'complainMsg',
  'dateTime',
  'isApproved',
];

const Complaints = () => {
  const classes = restaurantStyle();
  const navigate = useNavigate();
  const [type, setType] = useState('add');
  const [openDialog, setOpenDialog] = useState(false);
  const [status, setStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [inputValue, setInputValue] = useState({
    name: '',
    email: '',
    phoneNumber: '',
    address: '',
    status: '',
  });

  const [image, setImage] = useState('');
  const [category, setCategory] = useState('');
  const [allComplaints, setAllComplaints] = useState([]);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: '',
    message: '',
  });
  const [focus, setFocus] = useState(null);
  const [dateValues, setDateValues] = useState({
    startDate: null,
    endDate: null,
  });

  const handleOnDateChange = (startDate, endDate) => {
    let start = startDate.startDate;
    let end = startDate.endDate;
    setDateValues({
      startDate: start,
      endDate: end,
    });
  };

  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const getData = () => {
    setIsLoading(true);
    getAllComplaints()
      .then((response) => {
        setIsLoading(false);

        let tempArr = [];
        if (response.data.data.length > 0) {
          response.data.data.map((item) => {
            tempArr.push({
              userName: item.userDetails.name,
              email: item.userDetails.email,
              complainMsg: item.complainDetails.complainText,
              dateTime: moment(item.complainDetails.date).format(
                'DD-MM-YYYY hh:mm:ss A'
              ),
              isApproved: item.complainDetails.isRespond,
              _id: item.complainDetails._id,
            });
          });
          setAllComplaints(tempArr.reverse());
        } else setAllComplaints([]);
      })
      .catch((error) => {
        console.log(error, 'asdlskdjslkjdlk');
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const handleEditStatus = (e, row, type) => {
    e.stopPropagation();
    let approveParam = {
      isRespond: row.isApprove === 'InActive' ? 'Active' : 'InActive',
      complainId: row._id,
    };
    // setIsLoading(true);
    // updateRestStatus(approveParam)
    //   .then((res) => {
    //     getData();
    //     handleSnackbarVal(true, "success", res?.data?.message);
    //     setIsLoading(false);
    //   })
    //   .catch((err) => {
    //     setIsLoading(false);
    //     handleSnackbarVal(true, "error", err?.response?.data?.message);
    //   });
  };

  const handleClose = () => {
    setOpenDialog(false);
    setInputValue({
      name: '',
      email: '',
      phoneNumber: '',
      address: '',
    });
    setImage('');
    setCategory('');
  };

  // const handleDelete = (val) => {};

  const navigateToDetail = (row) => {
    navigate(`/restaurantDetail/${row.orderId}`, {
      state: row,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, '', '');
  };

  const handleUpdateRequestedCat = (row, type) => {
    let params = {
      requestedCategory: row.RequestedCategory,
      restId: row._id,
    };

    let payload = {
      restId: row._id,
    };

    if (type === 'accept') {
      setIsLoading(true);
      updateCategoryStatus(params)
        .then((res) => {
          getData();
          setIsLoading(false);
          handleSnackbarVal(true, 'success', res?.data?.message);
        })
        .catch((err) => {
          setIsLoading(false);
          handleSnackbarVal(true, 'error', err?.response?.data?.message);
        });
    } else {
      setIsLoading(true);
      updateCategoryStatusRejected(payload)
        .then((res) => {
          getData();
          setIsLoading(false);
          handleSnackbarVal(true, 'success', res?.data?.message);
        })
        .catch((err) => {
          setIsLoading(false);
          handleSnackbarVal(true, 'error', err?.response?.data?.message);
        });
    }
  };

  console.log(allComplaints, 'allComplaintsallComplaints');

  return (
    <NavigationDrawer>
      <Loader isloading={isLoading} />
      <SnackbarAlert
        snackbarProps={snackbarProps}
        handleCloseSnackbar={handleCloseSnackbar}
      />
      <Grid container alignItems='center' marginBottom={3}>
        <Grid item xs={12} md={2}>
          <Typography style={{ fontSize: '22px', fontWeight: '600' }}>
            Complaints
          </Typography>
        </Grid>
      </Grid>
      <div style={{ textAlign: 'right', margin: '20px 0' }}>
        <DateRangePicker
          isOutsideRange={() => false}
          startDatePlaceholderText='Start Date'
          startDate={dateValues.startDate}
          onDatesChange={handleOnDateChange}
          endDatePlaceholderText='End Date'
          endDate={dateValues.endDate}
          numberOfMonths={2}
          displayFormat='DD-MM-YYYY'
          showClearDates={true}
          focusedInput={focus}
          onFocusChange={(focus) => setFocus(focus)}
          startDateId='startDateMookh'
          endDateId='endDateMookh'
          minimumNights={0}
          small
          showDefaultInputIcon={false}
        />
        <TextField
          style={{ marginLeft: 10 }}
          placeholder='Search'
          size='small'
        />
      </div>

      <DynamicTable
        headerData={headerData}
        bodyRows={allComplaints}
        displayData={displayRows}
        showDelete={false}
        showEdit={false}
        // handleDelete={handleDelete}
        // openEditDialog={handleEditStatus}
        handleEditStatus={handleEditStatus}
        type={type}
        navigateToDetail={navigateToDetail}
        showSwitch={true}
        handleUpdateRequestedCat={handleUpdateRequestedCat}
      />

      <ComplaintsDialog
        open={openDialog}
        setOpenDialog={setOpenDialog}
        type={type}
        handleClose={handleClose}
        inputValue={inputValue}
        setInputValue={setInputValue}
        image={image}
        setImage={setImage}
        category={category}
        setCategory={setCategory}
        setStatus={setStatus}
        status={status}
      />
    </NavigationDrawer>
  );
};

export default Complaints;
